import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { UiNodeSpec } from './UiNodeSpec';

export const eventOneShotUiNodeSpec: UiNodeSpec<'eventOneShot'> = {
    requiredSockets: [ 'input', 'output' ],
    cfg: () => ({ id: getUID(), kind: 'eventOneShot', disabled: false }),
    controls: () => ({}),
    inputs: () => ({
        input: { socket: 'event', label: 'Input' },
        reset: { socket: 'event', label: 'Reset' },
    }),
    kindLabel: 'Event One Shot',
    nodeCategory: 'events',
    outputs: () => ({ output: { socket: 'event', label: 'Output' } }),
    validator: () => true,
};
